import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(", ");
  if (typeof detail.msg === "string") return detail.msg;
  return "Something went wrong";
}

const COLORS = {
  safe: "#00E599",
  warning: "#FFB800",
  critical: "#FF3815",
  overdue: "#FF3815",
};

export const statusColor = (status) => COLORS[status] || COLORS.safe;

export const FIELD_LABELS = {
  mot_due: "MOT",
  council_due: "Council test",
  tax_due: "Road tax",
};

// auto-refresh an expired access token once, then surface logouts app-wide
api.interceptors.response.use(undefined, async (error) => {
  const original = error.config;
  const status = error.response?.status;
  if (status === 401 && original && !original.__retried && !String(original.url || "").includes("/auth/")) {
    original.__retried = true;
    try {
      await api.post("/auth/refresh");
      return api(original);
    } catch (e) {
      window.dispatchEvent(new Event("auth:logout"));
      return Promise.reject(e);
    }
  }
  return Promise.reject(error);
});
